import {VerificationSchema, VerificationValues} from '@/forms/Register'
import alerts from '@/config/alerts.json'
import {
  Verification,
  ResendVerification,
  ResendVerificationEmail,
} from '@/services/api/auth'
import {Form, Formik, FormikHelpers} from 'formik'
import React, {Dispatch, SetStateAction} from 'react'
import toast from 'react-hot-toast'
import {useMutation} from 'react-query'
import BackButton from '../BackButton'
import SubmitButton from '../forms/SubmitButton'
import TextInput from '../forms/TextInput'
import Illustration from './Illustration'

interface Props {
  fromRegister?: boolean
  setIsLoginOpen: (arg0: boolean) => void
  setIsRegisterOpen: (arg0: boolean) => void
  setVerificationData: any
  setShouldVerify: any
  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
  phone: {country_code: string; number: string}
}
export default function Verifications({
  phone,
  setLastOpened,
  fromRegister = false,
  setIsLoginOpen,
  setIsRegisterOpen,
  setShouldVerify,
  setVerificationData,
}: Props) {
  const [isActive, setIsActive] = React.useState(false)

  function toggle() {
    setIsActive(!isActive)
  }

  const [seconds, setSeconds] = React.useState(60)

  React.useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds - 1)
    }, 1000)

    if (seconds === 0) {
      clearInterval(countdown)
    }

    return () => clearInterval(countdown)
  }, [seconds])
  const ResendMutation = useMutation(ResendVerification)
  const ResendEmailMutation = useMutation(ResendVerificationEmail)
  const VerificationMutation = useMutation(Verification)

  const handleVerification = () => {
    ResendMutation.mutate(
      {
        country_code: phone.country_code,
        number: phone.number,
      },
      {
        onSuccess() {
          setSeconds(60)
          toast.success(alerts.validation_code)
        },
        onError(error: any) {
          toast.error(error.response.data.message, {
            duration: 4000,
            id: 'Validation Error',
          })
        },
      },
    )
  }
  const handleVerificationEmail = () => {
    ResendEmailMutation.mutate(
      {
        country_code: phone.country_code,
        number: phone.number,
      },
      {
        onSuccess() {
          setSeconds(60)
          toast.success(alerts.validation_code)
        },
        onError(error: any) {
          toast.error(error.response.data.message, {
            duration: 4000,
            id: 'Validation Error',
          })
        },
      },
    )
  }
  const SubmitVerificationPhone = async (
    values: VerificationValues,
    actions: FormikHelpers<VerificationValues>,
  ) => {
    {
      VerificationMutation.mutate(
        {...phone, verification_code: values.code},
        {
          onSuccess() {
            toast.success(alerts.log_in_proceed)
            if (fromRegister) {
              setIsRegisterOpen(false)
              setTimeout(() => {
                setLastOpened('login')
                setIsLoginOpen(true)
              }, 200)
            }
            setShouldVerify(false)
            setVerificationData(undefined)
          },
          onError(error: any) {
            console.error(error, 'error')
            toast.error(error.response.data.message, {
              duration: 4000,
              id: 'Validation Error',
            })
          },
        },
      )
    }
  }
  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <div className="mt-0">
          <Illustration />
        </div>
        <Formik
          initialValues={{
            code: '',
          }}
          validationSchema={VerificationSchema}
          onSubmit={SubmitVerificationPhone}>
          {({errors, touched, values, setFieldValue, setFieldError}) => (
            <Form className="w-full mt-4">
              <div>
                <p className="text-right font-light text-text-color">
                  أدخل رمز التفعيل المرسل إلى هاتفك
                </p>
                <div className="form-group flex flex-col mt-1 w-full">
                  <TextInput
                    label={''}
                    type="text"
                    name="code"
                    placeholder={'أدخل رمز التفعيل'}
                    isError={errors.code && touched.code}
                    error={errors.code}
                  />
                </div>
                {!ResendMutation.isLoading ? (
                  <div className="text-right text-sm">
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault()
                        if (seconds == 0) {
                          handleVerification()
                        }
                      }}
                      className={`${
                        seconds === 0 ? 'text-black' : 'text-gray-500'
                      }`}>
                      أعد إرسال الرمز إلى الهاتف ({seconds}s)
                    </a>
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault()
                        if (seconds == 0) {
                          handleVerificationEmail()
                        }
                      }}
                      className={`mt-2 block ${
                        seconds === 0 ? 'text-black' : 'text-gray-500'
                      }`}>
                      أعد إرسال الرمز إلى البريد الإلكتروني ({seconds}s)
                    </a>
                  </div>
                ) : (
                  <svg
                    className="animate-spin ml-1 mr-3 h-5 w-5 text-primary"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                )}
              </div>

              <SubmitButton
                text={'ادخال الكود'}
                isLoading={VerificationMutation.isLoading}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}
